<template>
<v-card @mouseover="hover=true" @mouseleave="hover=false" height="100%">
    <v-card-title primary-title>
        <div class="hotel-card-title pa-2">
            {{ $t('hotel.card.contact.title') }}
        </div>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
                <div v-on="on" class="procent" @click="status_dialog = true">
                    <span :class="color + '--text'">
                        {{ procent_status }}%
                    </span>
                    <v-icon size="19" :color="color">info</v-icon>
                </div>
            </template>
            <div class="">
                <div class=" important white--text">
                    Rata completare <span class="text-lowercase"> {{ $t('hotel.card.contact.title') }} </span>
                </div>
                <div class="" v-if="!item.email">
                    Adresa de email este necesara pentru a tine legatura
                </div>
                <div class="" v-if="!item.static.defaults.phone">
                    Nr de telefon este necesar pentru a tine legatura
                </div>
                <div class="" v-if="!item.static.defaults.fax">
                    Nr de fax este necesar pentru a tine legatura
                </div>
                <div class="" v-if="!item.static.contact.person">
                    O persoana de contact este necesara pentru a tine legatura
                </div>
                <div class="" v-if="!item.static.contact.email">
                    Adresa de email de la persoana de contact este necesara pentru a tine legatura
                </div>
                <div class="" v-if="!item.static.contact.phone">
                    Nr de telefon de la persoana de contact este necesara pentru a tine legatura
                </div>
                <div class="" v-if="!item.static.contact.position">
                    Pozitia persoanei de contact este necesara pentru a sti cu cine tinem legatura
                </div>
                <div class="" v-if="!item.static.defaults.website">
                    Un website va ajuta la promovoare si noi clienti
                </div>
            </div>
        </v-tooltip>
        <v-icon class="pa-1 icon-edit" color="#5A8DEE" v-show="hover" @click="emitOpenDialog()">edit</v-icon>
    </v-card-title>
    <v-card-text>
        <v-row>
            <v-col md="6" cols="12" class="py-0">
                <div v-if="item.static.defaults.website" class="d-flex align-center">
                    <v-icon class="px-1" color="#5A8DEE">public</v-icon>
                    <div class="text-truncate">
                        {{item.static.defaults.website}}
                    </div>
                </div>
                <div class="d-flex align-center">
                    <v-icon class="px-1" color="#5A8DEE">mail</v-icon>
                    <div class="text-truncate">
                        {{item.email}}
                    </div>
                </div>
                <div class="d-flex align-center">
                    <v-icon class="px-1" color="#5A8DEE">phone</v-icon>
                    <div class="text-truncate">
                        {{item.static.defaults.phone}}
                    </div>
                </div>
                <div class="d-flex align-center" v-if="item.static.defaults.fax">
                    <v-icon class="px-1" color="#5A8DEE">local_printshop</v-icon>
                    <div class="text-truncate">
                        {{item.static.defaults.fax}}
                    </div>
                </div>
            </v-col>
            <v-col md="6" cols="12" class="py-0">
                <div class="d-flex align-center">
                    <v-icon class="px-1" color="#5A8DEE">person</v-icon>
                    <div class="text-truncate">
                        {{item.static.contact.person}}
                    </div>
                </div>
                <div class="d-flex align-center">
                    <v-icon class="px-1" color="#5A8DEE">mail</v-icon>
                    <div class="text-truncate">
                        {{item.static.contact.email}}
                    </div>
                </div>
                <div class="d-flex align-center" v-if="item.static.contact.phone">
                    <v-icon class="px-1" color="#5A8DEE">phone</v-icon>
                    <div class="text-truncate">
                        {{item.static.contact.phone}}
                    </div>
                </div>
            </v-col>
        </v-row>
    </v-card-text>

    <!--info dialog-->
    <v-dialog v-model="status_dialog" max-width="720">
        <v-card>
            <v-card-title class="hotel-card-title" primary-title>
                Info
            </v-card-title>
            <v-card-text class="info-text">
                <div class="" v-if="!item.email">
                    Adresa de email este necesara pentru a tine legatura
                </div>
                <div class="" v-if="!item.static.defaults.phone">
                    Nr de telefon este necesar pentru a tine legatura
                </div>
                <div class="" v-if="!item.static.defaults.fax">
                    Nr de fax este necesar pentru a tine legatura
                </div>
                <div class="" v-if="!item.static.contact.person">
                    O persoana de contact este necesara pentru a tine legatura
                </div>
                <div class="" v-if="!item.static.contact.email">
                    Adresa de email de la persoana de contact este necesara pentru a tine legatura
                </div>
                <div class="" v-if="!item.static.contact.phone">
                    Nr de telefon de la persoana de contact este necesara pentru a tine legatura
                </div>
                <div class="" v-if="!item.static.contact.position">
                    Pozitia persoanei de contact este necesara pentru a sti cu cine tinem legatura
                </div>
                <div class="" v-if="!item.static.defaults.website">
                    Un website va ajuta la promovoare si noi clienti
                </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="status_dialog=false">
                    {{ $t('button.exit') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!--./info dialog -->


</v-card>
</template>

<script>
import {
    mapActions
} from 'vuex';

export default {
    props: {
        item: Object,
        config: Object,
        active: Object
    },
    name: `hotel-contact`,
    components: {},
    data() {
        return {
            color: 'gray',
            procent_value: 5,
            status_dialog: false,
            hover: false
        };
    },

    watch: {},

    computed: {
        procent_status() {
            let procent = 0;
            if(this.item.static.defaults.website) {
                procent += 5;
            }
            if(this.item.static.defaults.phone) {
                procent += 15;
            }
            if(this.item.static.defaults.fax) {
                procent += 5;
            }
            if(this.item.email) {
                procent += 25;
            }
            if(this.item.static.contact.person) {
                procent += 15;
            }
            if(this.item.static.contact.email) {
                procent += 15;
            }
            if(this.item.static.contact.phone) {
                procent += 15;
            }
            if(this.item.static.contact.position) {
                procent += 5;
            }
            this.setColor(procent);
            return procent;
        }
    },

    methods: {

        ...mapActions('alert', ['success', 'error']),

        setColor(procent) {
            if(procent < 51) {
                this.color = 'red'
            }
            if(50 < procent && procent < 81) {
                this.color = 'orange'
            }
            if(procent > 80) {
                this.color = 'green'
            }
        },

        emitOpenDialog() {
            this.$emit('openDialog');
        }
    },

};
</script>

<style lang="stylus">
.procent
    position: absolute
    cursor: pointer
    right: 80px
    top: 18px
    color: #727e8c
    font-size: 15px
    @media screen and (max-width: 600px)
        right: 55px
.info-text
    color: #727e8c
    font-size: 15px
.icon-edit
    background-color: rgba(90,141,238, 0.2)
    border-radius: 50%
</style>
